<template>
  <div>
    <div>
      Satışı Durduruldu
    </div>
    <div>
      {{ getBlacklistReason || '' }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'Blacklisted',
  props: {
    product: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    getBlacklistReason () {
      return String(this.product.blacklistReason).replace(' - SPM', '');
    },
    isBlackListReasonDiffPrice () {
      return String(this.product.blacklistReason).trim() === 'Farklı adet/ebat ürün satışı';
    },
  },
};
</script>
